import { Center } from "@freightsimple/ui-core/PageLayout/Center";
import { Heading } from "@freightsimple/ui-core/Typography/Heading";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";

/**
 * Shown when a filter excludes every invoice.
 *
 * A heading plus a line of copy, centred in a region of its own — the same
 * shape as the other empty states in the app. It used to be a single long
 * sentence on one line beside a warning icon, which read as an error banner
 * rather than a state.
 */
export function InvoicesNoMatchesState() {
  return (
    <Center minHeight={240} maxWidth={576}>
      <Stack align="center" gap={2}>
        <Heading level={3}>No invoices match your filter</Heading>
        <T size="base" color="secondary" align="center">
          Please contact our customer support team if you believe this is an
          error.
        </T>
      </Stack>
    </Center>
  );
}
